import { AnnotationPlugin } from '@st/document-viewer-kit'
import { StampAnnotation } from '@st/sdk/src/sdk.types'
import { StampToolState } from '~/st-doc-viewer/annotations'
import { syncToolStateWithAnnotation, StampAnnotationElement, StampToolOverlay } from './ui'

export { StampToolEditor } from './ui'

export function stampPlugin(): AnnotationPlugin<StampAnnotation, StampToolState> {
  return {
    name: 'stamp',
    initialToolState: {
      name: 'stamp',
      settings: { templateId: undefined, stampSize: 20 }
    },
    ToolOverlay: StampToolOverlay,
    Element: StampAnnotationElement,
    handlesAnnotation: (annotation) => {
      if (annotation.type != 'stamp') return false
      const stamp = annotation as StampAnnotation
      return stamp.stampType == 'tick_mark' || stamp.stampType == 'number'
    },
    onAnnotationSelected: (event, send) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        send({ type: 'updateTool', tool: syncToolStateWithAnnotation(annotation) })
      }
    },
    onAnnotationDeselected: (event, send) => {
      if (!event.annotation && event.annotationDraft) {
        send({ type: 'createAnnotation', annotationDraft: event.annotationDraft })
      } else if (event.annotation && event.annotationDraft) {
        send({ type: 'updateAnnotation', annotationDraft: event.annotationDraft })
      }
    }
  }
}
